import { ApplicationMenuItem, ApplicationName, EnvType, getUrlByEnv } from '@mediacoach/ui'
import packageJson from '../../package.json'

const MAIN_APP_NAME = 'integratedapps'

const AUTH_DOMAIN = 'id'

export const VARIABLES_BY_ENVIRONMENT = {
  [EnvType.Dv]: {
    [ApplicationName.HudlSignal]: {
      REDIRECT_LOGGED_URL: 'https://testlaliga-az.wimucloud.com/',
      queryParams: [{ key: 'id_token', value: 'access_token' }],
      hasAuth: true,
    },
    [ApplicationName.Coachvision]: {
      REDIRECT_LOGGED_URL: 'http://liga.footovision.com/oidc/get-tokens.html',
      queryParams: [],
    },
  },
  [EnvType.Ts]: {
    [ApplicationName.HudlSignal]: {
      REDIRECT_LOGGED_URL: 'https://testlaliga-az.wimucloud.com/',
      queryParams: [{ key: 'id_token', value: 'access_token' }],
      hasAuth: true,
    },
    [ApplicationName.Coachvision]: {
      REDIRECT_LOGGED_URL: 'https://pre-mediacoachvision.laliga.es/oidc/get-tokens.html',
      queryParams: [],
    },
  },
  [EnvType.Qa]: {
    [ApplicationName.HudlSignal]: {
      REDIRECT_LOGGED_URL: 'https://testlaliga-az.wimucloud.com/',
      queryParams: [{ key: 'id_token', value: 'access_token' }],
      hasAuth: true,
    },
    [ApplicationName.Coachvision]: {
      REDIRECT_LOGGED_URL: 'https://pre-mediacoachvision.laliga.es/oidc/get-tokens.html',
      queryParams: [],
    },

    GOOGLE_ANALYTICS_TRACKING_CODE: 'UA-113083612-2',
  },
  [EnvType.Pr]: {
    production: true,

    [ApplicationName.HudlSignal]: {
      REDIRECT_LOGGED_URL: 'https://mediacoach.wimucloud.com/',
      queryParams: [{ key: 'id_token', value: 'access_token' }],
      hasAuth: true,
    },
    [ApplicationName.Coachvision]: {
      REDIRECT_LOGGED_URL: 'https://mediacoachvision.laliga.es/oidc/get-tokens.html',
      queryParams: [],
    },

    GOOGLE_ANALYTICS_TRACKING_CODE: 'UA-113371562-2',
  },
}

const getEnvironmentInfo = (env: EnvType) => {
  const { APP_DOMAIN, IDENTITY_SERVER } = getDomainInfo(env)
  const ORIGIN_DOMAIN = window.location.origin
  return {
    production: false,
    serverMocks: false,

    BUILD_VERSION: packageJson.version,

    APP_DOMAIN,

    ORIGIN_DOMAIN,

    API_KEY_SECURE: 'Bearer',
    GENERAL_DEBOUNCE_TIME: 200,

    // FRONT URLS
    REDIRECT_APPLICATIONS_URL: '/applications',
    NOT_PERMITTED_URL: '/not-permitted',

    [ApplicationName.HudlSignal]: {
      REDIRECT_LOGGED_URL: 'https://testmediacoach.wimucloud.com/',
      queryParams: [{ key: 'id_token', value: 'access_token' }],
      hasAuth: true,
    },
    [ApplicationName.Coachvision]: {
      REDIRECT_LOGGED_URL: 'http://liga.footovision.com/oidc/get-tokens.html',
      queryParams: [],
    },
    [ApplicationName.SCISports]: {
      REDIRECT_LOGGED_URL: 'https://performance.scisports.app/',
      queryParams: [],
    },


    I18N_LANGS: {
      es: { locale: 'es-ES', i18nLabel: 'MTR_COMMON_LANG_ES' },
      en: { locale: 'en-GB', i18nLabel: 'MTR_COMMON_LANG_EN' },
    },

    GOOGLE_ANALYTICS_TRACKING_CODE: 'UA-108719301-2',

    IDENTITY_SERVER: {
      API_LOGOUT: `${IDENTITY_SERVER}/connect/endsession`,
      API_TOKEN: `${IDENTITY_SERVER}/connect/token`,
      AUTHORITY_URL: IDENTITY_SERVER,
      REDIRECT_URI: {
        [ApplicationName.HudlSignal]: `${ORIGIN_DOMAIN}/auth/Wimu`,
      },
      REGISTER_ACCOUNT_URL: `${IDENTITY_SERVER}/Account/Register`,
      POST_LOGOUT_REDIRECT_URI: APP_DOMAIN,
      TAG_POST_LOGOUT_REDIRECT_URI: 'post_logout_redirect_uri',
      SILENT_REDIRECT_URI: `${ORIGIN_DOMAIN}/silent`,
      ACCESS_TOKEN_EXPIRING_NOTIFICATION_TIME: 4,
      LOAD_USER_INFO: true,
      RESPONSE_TYPE: {
        [ApplicationName.HudlSignal]: 'token id_token',
      },
      SCOPE: {
        [ApplicationName.HudlSignal]: 'openid profile wimu-api-accountmanager',
      },
      CLIENT_ID: {
        [ApplicationName.HudlSignal]: '39f134d0-779a-061a-01c0-e3b6eb42a9cb',
      },
    },
  }
}

const getDomainInfo = (env: EnvType) => ({
  APP_DOMAIN: getUrlByEnv(env, {
    id: 'main-app',
    name: MAIN_APP_NAME,
    domain: `https://${MAIN_APP_NAME}.mediacoach.es`
  } as ApplicationMenuItem),

  IDENTITY_SERVER: getUrlByEnv(env, {
    id: 'auth-server',
    name: AUTH_DOMAIN,
    domain: `https://${AUTH_DOMAIN}.mediacoach.es`
  } as ApplicationMenuItem),
})

export const getEnvironment = (env: EnvType) => ({
  envType: env,

  ...getEnvironmentInfo(env),

  ...VARIABLES_BY_ENVIRONMENT[env],

  // Keep this comment untouched. Bamboo will replace it with the following
  // environment variables:
  //
  //     BUILD_VERSION, BUILD_NUM, BUILD_DATE, BUILD_BRANCH, BUILD_COMMIT
  //
  // {{ COMPILATION_VARS }}
})
